import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import cloudProvidersState from './state';
const cloudProvidersSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => cloudProvidersState);
    },
    initialState: cloudProvidersState,
    name: 'cloudProviders',
    reducers: {
        errorReceiveCloudProviders: state => {
            state.cloudProviders = undefined;
            state.requestingCloudProviders = false;
        },
        failedReceiveCloudProviders: state => {
            state.cloudProviders = undefined;
            state.requestingCloudProviders = false;
        },
        receiveCloudProviders: {
            prepare: cloudProviders => {
                return {
                    payload: {
                        cloudProviders
                    }
                };
            },
            reducer: (state, action) => {
                const { cloudProviders } = action.payload;
                state.cloudProviders = cloudProviders;
                state.requestingCloudProviders = false;
            }
        },
        requestCloudProviders: state => {
            state.requestingCloudProviders = true;
        },
        resetCloudProviders: () => cloudProvidersState
    }
});
export const { errorReceiveCloudProviders, failedReceiveCloudProviders, receiveCloudProviders, requestCloudProviders, resetCloudProviders } = cloudProvidersSlice.actions;
export default cloudProvidersSlice.reducer;
